import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { GoodreadsLogo, Stars } from "@/components/site/brands";

export default function Testimonials({ testimonials, config }) {
  const goodreads = config?.goodreads_author_url || "#";
  if (!testimonials?.length) return null;
  return (
    <section id="reviews" className="py-28 sm:py-36">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="flex flex-col items-center text-center mb-16">
          <Stars rating={5} size={22} className="mb-4" />
          <div className="flex items-center gap-2 mb-4">
            <span className="text-[11px] uppercase tracking-[0.3em] text-gray-500 font-semibold">Reviewed by readers on</span>
            <GoodreadsLogo className="h-5 w-auto" />
          </div>
          <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">What Readers Are Saying</h2>
          <p className="text-gray-500 mt-4 max-w-xl text-[15px]">
            Independent reader reviews from the Goodreads community — honest, unfiltered validation.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <motion.blockquote
              key={t.id || i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className="relative bg-white border border-gray-100 rounded-3xl p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] gold-glow"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="text-gold/30 absolute top-6 right-6" size={40} />
              <Stars rating={t.rating || 5} size={16} />
              <p className="text-gray-700 leading-relaxed mt-5 text-[15px]">"{t.text}"</p>
              <footer className="mt-6 pt-5 border-t border-gray-100">
                <p className="font-semibold text-sm">{t.name}</p>
                <p className="text-xs text-gray-500 mt-0.5">{t.book_title} · {t.source}</p>
              </footer>
            </motion.blockquote>
          ))}
        </div>

        <div className="flex justify-center mt-12">
          <a
            href={goodreads}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="testimonials-goodreads-cta"
            className="btn-ink btn-pill"
          >
            Read More Reviews on
            <span className="bg-white rounded-md px-2 py-1"><GoodreadsLogo className="h-4 w-auto" /></span>
          </a>
        </div>
      </div>
    </section>
  );
}
